import { gql } from '@apollo/client';

export const M_CREATE_EMPLEADO = gql`
  mutation CreateEmpleado($input: CreateEmpleadoInput!) {
    createEmpleado(input: $input) {
      id
      nombre
      apellido
      legajo
      estado
    }
  }
`;

export const M_UPDATE_EMPLEADO = gql`
  mutation UpdateEmpleado($id: ID!, $input: UpdateEmpleadoInput!) {
    updateEmpleado(id: $id, input: $input) {
      id
      nombre
      apellido
      legajo
      estado
    }
  }
`;

export const M_DELETE_EMPLEADO = gql`
  mutation DeleteEmpleado($id: ID!) {
    deleteEmpleado(id: $id)
  }
`;

export const M_RESTORE_EMPLEADO = gql`
  mutation RestoreEmpleado($id: ID!) {
    restoreEmpleado(id: $id)
  }
`;
